import { ChatMessageData } from './types';

export const createAssistantMessage = (content: string): ChatMessageData => ({
  role: 'assistant',
  content,
});
export const createUserMessage = (content: string): ChatMessageData => ({
  role: 'user',
  content,
});
